export const screenNumber = '1 of 3'
export const NEXT = 'Next'